module.exports = {"340173001":"七里塘街道","340173002":"磨店街道","340173003":"三十头街道","340173400":"瑶海社区服务中心","340173401":"站北社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340173.json
// module id = 1148
// module chunks = 0